import * as React from 'react';
import { Form, Input, Select, Button } from 'antd';

interface EmployeeFormProps {
  form: any;
  initialValues?: any;
  onFinish: (values: any) => void;
  loading?: boolean;
  submitText?: string;
  hideFields?: string[];
  companies?: any[];
  isSuperAdmin?: boolean;
  currentUser?: any;
  userList?: { id: number; username: string }[];
  locations?: any[]; // Thêm prop locations
}

const EmployeeForm = ({
  form,
  initialValues = {},
  onFinish,
  loading = false,
  submitText = 'Lưu',
  hideFields = [],
  companies = [],
  isSuperAdmin = false,
  currentUser,
  userList = [],
  locations = [], // Mặc định mảng rỗng
}: EmployeeFormProps): React.ReactElement => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      {!hideFields.includes('full_name') && (
        <Form.Item
          name="full_name"
          label="Tên nhân viên"
          rules={[{ required: true, message: 'Nhập tên nhân viên!' }]}
        >
          <Input
            className="ams-input"
            placeholder="Tên nhân viên"
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
          />
        </Form.Item>
      )}

      {!hideFields.includes('employee_code') && (
        <Form.Item name="employee_code" label="Mã NV">
          <Input
            className="ams-input"
            placeholder="Mã NV"
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
          />
        </Form.Item>
      )}

      {!hideFields.includes('department') && (
        <Form.Item name="department" label="Phòng ban">
          <Input
            className="ams-input"
            placeholder="Phòng ban"
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
          />
        </Form.Item>
      )}

      {/* Trường công ty */}
      {!hideFields.includes('company_id') && isSuperAdmin ? (
        <Form.Item
          name="company_id"
          label="Công ty"
          rules={[{ required: true, message: 'Chọn công ty!' }]}
        >
          <Select
            className="ams-input"
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
            placeholder="Chọn công ty"
            options={companies.map((company: any) => ({
              value: company.id,
              label: company.name,
            }))}
          />
        </Form.Item>
      ) : !hideFields.includes('company_id') && (
        <Form.Item label="Công ty">
          <Input
            value={companies.find((c: any) => c.id === currentUser?.company_id)?.name || ''}
            disabled
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
          />
        </Form.Item>
      )}

      {/* Thêm trường chọn vị trí (Kiểm soát tài sản) */}
      <Form.Item name="managed_location_ids" label="Kiểm soát tài sản">
        <Select
          mode="multiple"
          className="ams-input"
          size="large"
          style={{ width: '100%', borderRadius: 8, minHeight: 40 }}
          placeholder="Chọn các vị trí để gán quyền Kiểm soát tài sản"
          allowClear
          showSearch
          optionFilterProp="children"
          options={locations.map((loc: any) => ({
            value: loc.id,
            label: loc.name,
          }))}
        />
      </Form.Item>

      {/* Thêm trường chọn tài khoản người dùng */}
      <Form.Item name="user_id" label="Tài khoản người dùng">
        <Select
          placeholder="Chọn tài khoản"
          allowClear
          showSearch
          optionFilterProp="children"
          options={userList.map(user => ({ value: user.id, label: user.username }))}
        />
      </Form.Item>

      <Form.Item style={{ marginBottom: 0 }}>
        <Button
          className="ams-btn"
          type="primary"
          htmlType="submit"
          size="large"
          loading={loading}
          style={{ width: '100%', borderRadius: 8, height: 40 }}
        >
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default EmployeeForm; 